import styled from 'styled-components';
import { theme } from '../../../styles/theme';

export default styled.div`
  margin-top: 4px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  color: ${theme.colors.secondary800};
`;
